import { actionTypes } from './actions';

const initialState = {
  list: {
    loading: false,
    list: [],
    count: 0,
    params: {}
  },
  one: {
    loading: false,
    data: null
  },
  groups: {
    loading: false,
    list: [],
    count: 0,
    params: {}
  },
  sessions: {
    loading: false,
    list: [],
    count: 0,
    params: {}
  }
};

const UsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LIST: {
      const { payload = {} } = action;
      const { list = {} } = state;
      return {
        ...state,
        list: {
          ...list,
          ...payload
        }
      };
    }
    case actionTypes.DELETE_ONE:
    case actionTypes.GET_ONE:
    case actionTypes.CREATE_ONE:
    case actionTypes.UPDATE_ONE: {
      const { one = {} } = state;
      const { payload = {} } = action;
      return {
        ...state,
        one: {
          ...one,
          ...payload
        }
      };
    }
    case actionTypes.GET_LIST_GROUPS: {
      const { payload = {} } = action;
      const { groups = {} } = state;
      return {
        ...state,
        groups: {
          ...groups,
          ...payload
        }
      };
    }
    case actionTypes.GET_LIST_SESSIONS: {
      const { payload = {} } = action;
      const { sessions = {} } = state;
      return {
        ...state,
        sessions: {
          ...sessions,
          ...payload
        }
      };
    }
    default:
      return state;
  }
};

export default UsersReducer;
